function addUpsellToCart(thisButton) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer') || document.querySelector('cart-items');
    var submitButton = thisButton;
    var form = document.querySelector('[id^="product-upsell-template-' + thisButton.dataset.formid + '--"]');
    if (document.querySelector('cart-drawer')) submitButton.setAttribute('aria-haspopup', 'dialog');

    if (submitButton.getAttribute('aria-disabled') === 'true') return;

    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');
    submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(form);
    if (thisButton.dataset.cartType != 'page') {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
            if (response.status) {
                submitButton.setAttribute('aria-disabled', true);
                submitButton.querySelector('span').classList.add('hidden');
                return;
            }
            thisButton.error = false;
            if (thisButton.dataset.cartType != 'page') {
                cart.renderContents(response);
            } else {
                window.location.href = window.location.href
            }
        })
        .catch((e) => {
            console.error(e);
        })
        .finally(() => {
            submitButton.classList.remove('loading');
            if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
}

function changeVariantEvent(thisVariant) {
    thisVariant.closest('.product-upsell-template').querySelector('#formUpsellId').value = thisVariant.value
}

initUpsellSlider()

function initUpsellSlider() {
    var upsellsContainer = document.querySelector('.cart-drawer-upsell-wrapper')
    var upsells = document.querySelectorAll('.cart-drawer-upsell_container');
    var nbOfUpsells = upsells.length - 1;

    if(upsellsContainer == null) return

    if(upsells.length == 1) {
        document.querySelectorAll('.sliderButton').forEach(button => {
            button.style.display = "none"
        })
        document.querySelector('.cart-drawer-upsell_container').style.paddingLeft = "0"
        document.querySelector('.cart-drawer-upsell_container').style.paddingRight = "0"
    }

    if (upsells[0] != null) {   
        upsells[0].style.display = "flex";
        upsellsContainer.dataset.currentSlide = 0;
        upsellsContainer.dataset.nextSlide = 1;
        upsellsContainer.dataset.prevSlide = nbOfUpsells;
        if (nbOfUpsells > 1) {
            document.querySelectorAll('.cart-drawer-upsell_container').forEach((item) => {
                item.classList.add('hasSlider')
            })
        }
    }
}

function prevSlide() {
    var upsellsContainer = document.querySelector('.cart-drawer-upsell-wrapper')
    var upsells = document.querySelectorAll('.cart-drawer-upsell_container');
    var nbOfUpsells = upsells.length - 1;
    upsells[upsellsContainer.dataset.currentSlide].style.display = "none";
    upsells[upsellsContainer.dataset.prevSlide].style.display = "flex";

    var mightBePrev = parseInt(upsellsContainer.dataset.currentSlide) - 1;

    if (mightBePrev == 0) {
        upsellsContainer.dataset.currentSlide = 0;
        upsellsContainer.dataset.nextSlide = 1;
        upsellsContainer.dataset.prevSlide = nbOfUpsells;
        return
    }

    if (mightBePrev < 0) {
        upsellsContainer.dataset.currentSlide = nbOfUpsells;
        upsellsContainer.dataset.nextSlide = 0;
    } else {
        upsellsContainer.dataset.currentSlide--;
        upsellsContainer.dataset.nextSlide = parseInt(upsellsContainer.dataset.currentSlide) + 1;
    }
    upsellsContainer.dataset.prevSlide = parseInt(upsellsContainer.dataset.currentSlide) - 1;
}

function nextSlide() {
    var upsellsContainer = document.querySelector('.cart-drawer-upsell-wrapper')
    var upsells = document.querySelectorAll('.cart-drawer-upsell_container');
    var nbOfUpsells = upsells.length - 1;
    upsells[upsellsContainer.dataset.currentSlide].style.display = "none";
    upsells[upsellsContainer.dataset.nextSlide].style.display = "flex";

    var mightBeNext = parseInt(upsellsContainer.dataset.currentSlide) + 1;

    if (mightBeNext == nbOfUpsells) {
        upsellsContainer.dataset.currentSlide = nbOfUpsells;
        upsellsContainer.dataset.nextSlide = 0;
        upsellsContainer.dataset.prevSlide = nbOfUpsells - 1;
        return
    }

    if (mightBeNext > nbOfUpsells) {
        upsellsContainer.dataset.currentSlide = 0;
        upsellsContainer.dataset.prevSlide = nbOfUpsells;
    } else {
        upsellsContainer.dataset.currentSlide++;
        upsellsContainer.dataset.prevSlide = parseInt(upsellsContainer.dataset.currentSlide) - 1;
    }
    upsellsContainer.dataset.nextSlide = parseInt(upsellsContainer.dataset.currentSlide) + 1;
}


/* ===== Upsell toggle v3 (ajout a l'add-to-cart, sans mouvement) ===== */
(function(){
  if(document.querySelector('style[data-upsell-toggle]')) return;
  var css=''
  +'.upsell-switch{position:relative;display:inline-block;width:46px;height:26px;flex:0 0 auto}'
  +'.upsell-switch .upsell-toggle-input{opacity:0;width:0;height:0;position:absolute;margin:0}'
  +'.upsell-switch__slider{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background:#ccc;border-radius:26px;transition:.25s}'
  +'.upsell-switch__slider:before{content:"";position:absolute;height:20px;width:20px;left:3px;top:3px;background:#fff;border-radius:50%;transition:.25s;box-shadow:0 1px 3px rgba(0,0,0,.3)}'
  +'.upsell-switch .upsell-toggle-input:checked + .upsell-switch__slider{background:#1b1b1b}'
  +'.upsell-switch .upsell-toggle-input:checked + .upsell-switch__slider:before{transform:translateX(20px)}'
  +'.upsell-switch .upsell-toggle-input:disabled + .upsell-switch__slider{opacity:.55;cursor:default}';
  var st=document.createElement('style');st.setAttribute('data-upsell-toggle','1');st.textContent=css;document.head.appendChild(st);
})();
function _upsellCartEl(){ return document.querySelector('cart-items')||document.querySelector('cart-drawer')||document.querySelector('cart-notification'); }
function _upsellSecId(s){ return s.section||s.id; }
function _upsellSwap(cartEl,parsed){
  if(!cartEl||typeof cartEl.getSectionsToRender!=='function'||!parsed||!parsed.sections) return false;
  var did=false;
  cartEl.getSectionsToRender().forEach(function(section){
    var host=document.getElementById(section.id); if(!host) return;
    var el=host.querySelector(section.selector)||host;
    var html=parsed.sections[_upsellSecId(section)];
    if(html!=null && typeof cartEl.getSectionInnerHTML==='function'){ el.innerHTML=cartEl.getSectionInnerHTML(html,section.selector); did=true; }
  });
  return did;
}
function _upsellFallback(cartEl,resp){ if(cartEl&&typeof cartEl.renderContents==='function'){cartEl.renderContents(resp);} else {window.location.reload();} }
function toggleUpsell(cb){
  if(cb.dataset.busy==='1') return;
  var vid=cb.dataset.variantId;
  if(cb.checked){ try{sessionStorage.removeItem('upsellOptout_'+vid);}catch(e){} _upsellToggleAdd(cb); }
  else { try{sessionStorage.setItem('upsellOptout_'+vid,'1');}catch(e){} _upsellToggleRemove(cb); }
}
function _upsellToggleAdd(cb){
  cb.dataset.busy='1'; cb.disabled=true;
  var cartEl=_upsellCartEl();
  var form=document.querySelector('[id^="product-upsell-template-'+cb.dataset.formid+'--"]');
  var config=fetchConfig('javascript'); config.headers['X-Requested-With']='XMLHttpRequest'; delete config.headers['Content-Type'];
  var fd=new FormData(form);
  if(cartEl&&typeof cartEl.getSectionsToRender==='function'){ fd.append('sections',cartEl.getSectionsToRender().map(_upsellSecId).join(',')); fd.append('sections_url',window.location.pathname); }
  config.body=fd;
  fetch(routes.cart_add_url,config).then(function(r){return r.json();}).then(function(resp){
    if(!_upsellSwap(cartEl,resp)) _upsellFallback(cartEl,resp);
  }).catch(function(e){console.error(e); cb.checked=false;}).finally(function(){cb.dataset.busy=''; cb.disabled=false;});
}
/* GLS 14/09/2026 : quand c'est NOUS qui vidons le panier (retrait de l'add-on juste
   apres que le client a supprime son dernier produit), le theme a deja applique son
   etat "panier garni" une fraction de seconde plus tot, alors que le panier contenait
   encore l'add-on. Les sections annexes (banniere promo, minuteur, pied de panier) ne
   se remettent pas a jour toutes seules. On recharge la page panier pour retomber sur
   l'etat vide rendu par Liquid, exactement celui d'une arrivee directe. */
function _upsellSyncEmptyState(resp){
  try{
    if(!resp || typeof resp.item_count!=='number' || resp.item_count>0) return;
    if(!/(^|\/)cart(\/|$)/.test(window.location.pathname)) return;
    var ci=document.querySelector('cart-items');
    if(ci && ci.classList.contains('is-empty')) return;   /* deja dans le bon etat */
    window.location.reload();
  }catch(e){}
}
function _upsellToggleRemove(cb){
  cb.dataset.busy='1'; cb.disabled=true;
  var cartEl=_upsellCartEl();
  var sections=[]; if(cartEl&&typeof cartEl.getSectionsToRender==='function') sections=cartEl.getSectionsToRender().map(_upsellSecId);
  var body=JSON.stringify({ id:String(cb.dataset.variantId), quantity:0, sections:sections, sections_url:window.location.pathname });
  fetch(routes.cart_change_url, Object.assign({}, fetchConfig(), {body:body})).then(function(r){return r.text();}).then(function(state){
    var resp=JSON.parse(state);
    if(!_upsellSwap(cartEl,resp)) _upsellFallback(cartEl,resp);
    _upsellSyncEmptyState(resp);
  }).catch(function(e){console.error(e); cb.checked=true;}).finally(function(){cb.dataset.busy=''; cb.disabled=false;});
}
var _upsellAutoTried={};
function reconcileUpsells(){
  var toggles=document.querySelectorAll('.upsell-toggle-input[data-default-on="true"]');
  var allToggles=document.querySelectorAll('.upsell-toggle-input');
  if(!allToggles.length) return;
  fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
    var upVids=(window.__autoUpsells||[]).map(function(u){return String(u.variantId);});
    for(var t=0;t<allToggles.length;t++){ upVids.push(String(allToggles[t].dataset.variantId)); }
    var real=0;
    (cart.items||[]).forEach(function(it){ if(upVids.indexOf(String(it.variant_id))===-1) real++; });
    /* GLS 13/09/2026 : la visibilite du bloc suit le panier en direct. Le Liquid ne
       decide qu'au chargement ; ici on couvre les allers-retours (ajout, retrait,
       suppression du dernier article) ou le theme ne re-rend que la liste d'articles. */
    for(var v=0;v<allToggles.length;v++){
      var _c=allToggles[v].closest?allToggles[v].closest('.cart-drawer-upsell_container'):null;
      if(!_c) continue;
      if(real===0){ _c.style.display='none'; _c.setAttribute('aria-hidden','true'); }
      else { _c.style.display=''; _c.removeAttribute('aria-hidden'); }
    }
    /* GLS 14/09/2026 : la banniere promo et le minuteur de reservation sont reveles une
       seule fois, au chargement, par un script qui teste la presence de la table
       d'articles. Vide le panier sans recharger et ils restent affiches au-dessus d'un
       panier vide. On les raccroche a la meme surveillance. On se contente de MASQUER :
       leur logique d'apparition (panier garni, remise presente) reste celle du theme. */
    if((cart.item_count||0)===0){
      var _horsPanier=['.cart-timer','.offer-coupon'];
      for(var h=0;h<_horsPanier.length;h++){
        var _el=document.querySelector(_horsPanier[h]);
        if(_el) _el.style.display='none';
      }
    }
    for(var i=0;i<toggles.length;i++){
      var cb=toggles[i]; if(cb.dataset.busy==='1') continue;
      var vid=cb.dataset.variantId;
      var inCart=(cart.items||[]).some(function(it){ return String(it.variant_id)===String(vid); });
      var optout=false; try{ optout=sessionStorage.getItem('upsellOptout_'+vid)==='1'; }catch(e){}
      if(real===0 && inCart){ cb.checked=false; _upsellToggleRemove(cb); return; }
      if(real>0 && !inCart && !optout && !_upsellAutoTried[vid]){ _upsellAutoTried[vid]=true; cb.checked=true; _upsellToggleAdd(cb); return; }
    }
  }).catch(function(){});
}
var _reconSched=false;
function _scheduleReconcile(){ if(_reconSched) return; _reconSched=true; setTimeout(function(){ _reconSched=false; reconcileUpsells(); }, 300); }
function _initUpsellReconcile(){
  reconcileUpsells();
  var host=document.getElementById('main-cart-items')||document.querySelector('cart-items')||document.querySelector('cart-drawer');
  if(host && window.MutationObserver){ new MutationObserver(_scheduleReconcile).observe(host,{childList:true,subtree:true}); }
}
if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', _initUpsellReconcile); } else { _initUpsellReconcile(); }
